import React from "react";
import PageShell from "../components/layout/PageShell";

export default function Accessibilite() {
  return (
    <PageShell
      title="Accessibilité"
      subtitle="Déclaration d’accessibilité et engagement d’amélioration continue."
    >
      <h2 className="ema-h3">Engagement</h2>
      <p className="ema-paragraph">
        L’École de la Magistrature s’engage à rendre son site accessible au plus grand nombre. Nous travaillons à améliorer
        l’accessibilité des contenus et des fonctionnalités.
      </p>

      <div className="ema-divider" />

      <h2 className="ema-h3">État de conformité</h2>
      <p className="ema-paragraph">
        Le site est <strong>partiellement conforme</strong> aux bonnes pratiques d’accessibilité. Des améliorations sont en cours.
      </p>

      <div className="ema-divider" />

      <h2 className="ema-h3">Améliorations prévues</h2>
      <ul className="ema-list">
        <li>Amélioration du contraste et de la lisibilité</li>
        <li>Navigation clavier complète</li>
        <li>Structure sémantique renforcée (titres, repères, ARIA)</li>
        <li>Optimisation pour lecteurs d’écran</li>
        <li>Textes alternatifs sur les images clés</li>
      </ul>

      <div className="ema-divider" />

      <h2 className="ema-h3">Assistance</h2>
      <p className="ema-paragraph">
        Si vous rencontrez une difficulté d’accès à un contenu ou service, veuillez nous contacter via la page <strong>Contact</strong>
        afin que nous vous proposions une alternative.
      </p>
    </PageShell>
  );
}

